<template>
  <tab-page-template
      fit>
    <template #toolbar-items>
      <v-toolbar-title class="with-divider">
        取引契約フォーマット管理
      </v-toolbar-title>
    </template>

    <template #tab-items>
      <v-tab :to="{name: tabRoute('/format')}">取引契約フォーマット</v-tab>
      <v-tab :to="{name: tabRoute('/formatGroup')}">取引契約フォーマットグループ</v-tab>
    </template>

    <template #after-tabs>
      <router-view>
      </router-view>
    </template>
  </tab-page-template>
</template>

<script>
import TabPageTemplate from "@/components/templates/TabPageTemplate.vue";
import IconBtn from "@/components/molecules/IconBtn.vue";

export default {
  components: {
    TabPageTemplate,
  },
  methods: {
    tabRoute(name) {
      const routeBase = this.$route.name.replace(/^(\/[^/]+\/[^/]+\/[^/]+).*$/, '$1');
      return `${routeBase}${name}`;
    },
  }
}
</script>
